document.addEventListener("DOMContentLoaded", ()=>{

let carrito = JSON.parse(localStorage.getItem("carrito")) || [];

const carritoContainer = document.getElementById("carrito-container");
const carritoTotalEl = document.getElementById("carrito-total");
const carritoEnvioEl = document.getElementById("carrito-envio");
const mensajeEnvioEl = document.getElementById("mensaje-envio");
const mensajePedidoEl = document.getElementById("mensaje-pedido");

const regionSelect = document.getElementById("region-select");

const vaciarBtn = document.getElementById("vaciar-carrito");
const comprarBtn = document.getElementById("comprar-carrito");

const UMBRAL_ENVIO_GRATIS = 200000; // Ejemplo: envío gratis para pedidos >= $200.000


/* =========================
ACTUALIZAR CONTADOR ICONO
========================= */

function actualizarContador(){

const cartCount = document.querySelector(".cart-count");

if(!cartCount) return;

const total = carrito.reduce((acc,item)=> acc + item.cantidad ,0);

cartCount.textContent = total;

}


/* =========================
CALCULAR ENVIO
========================= */

function calcularEnvio(subtotal){

if(subtotal >= UMBRAL_ENVIO_GRATIS){
return 0;
}

return parseFloat(regionSelect.selectedOptions[0].dataset.envio);

}


/* =========================
MOSTRAR CARRITO
========================= */

function mostrarCarrito(){

carritoContainer.innerHTML = "";

if(carrito.length === 0){

carritoContainer.innerHTML = "<p>Tu carrito está vacío</p>";

carritoTotalEl.textContent = "Total: $0.00";
carritoEnvioEl.textContent = "Envío: $0.00";
mensajeEnvioEl.textContent = "";

actualizarContador();

return;

}

let subtotal = 0;

carrito.forEach(item=>{

const itemSubtotal = item.precio * item.cantidad;

subtotal += itemSubtotal;

const div = document.createElement("div");

div.style.display = "flex";
div.style.justifyContent = "space-between";
div.style.alignItems = "center";
div.style.marginBottom = "1rem";
div.style.padding = "0.5rem";
div.style.borderBottom = "1px solid #444";

div.innerHTML = `
<div>
<strong>${item.nombre}</strong><br>
$${item.precio.toFixed(2)} x ${item.cantidad} = $${itemSubtotal.toFixed(2)}
</div>

<button class="btn-carrito btn-eliminar" data-id="${item.id}">
Eliminar
</button>
`;

div.querySelector(".btn-eliminar").addEventListener("click", ()=>{

carrito = carrito.filter(p => p.id !== item.id);

localStorage.setItem("carrito", JSON.stringify(carrito));

actualizarContador();

mostrarCarrito();

});

carritoContainer.appendChild(div);

});

const envio = calcularEnvio(subtotal);

// Detectar si la opción seleccionada es "cotizar otra ciudad"
const opcionCotizar = regionSelect.value === "5";

if(opcionCotizar){
    carritoEnvioEl.textContent = `Envío: Por cotizar`;
    mensajeEnvioEl.textContent = "El costo de envío se cotiza según la ciudad.";
} else {
    carritoEnvioEl.textContent = `Envío: $${envio.toFixed(2)}`;
    mensajeEnvioEl.textContent = envio === 0 ? "¡Envío gratis!" : "";
}

// Total siempre suma subtotal + envio (envio = 0 si supera umbral)
carritoTotalEl.textContent = `Total: $${(subtotal + envio).toFixed(2)}`;

actualizarContador();

}


/* =========================
VACIAR CARRITO
========================= */

vaciarBtn.addEventListener("click", ()=>{

carrito = [];

localStorage.setItem("carrito", JSON.stringify(carrito));

actualizarContador();

mostrarCarrito();

});


/* =========================
CAMBIAR REGION
========================= */

regionSelect.addEventListener("change", mostrarCarrito);


/* =========================
COMPRAR
========================= */

comprarBtn.addEventListener("click", async ()=>{

if(carrito.length === 0){

alert("El carrito está vacío");

return;

}

const nombre = document.getElementById("nombre").value.trim();
const apellido = document.getElementById("apellido").value.trim();
const direccion = document.getElementById("direccion").value.trim();
const telefono = document.getElementById("telefono").value.trim();

if(!nombre || !apellido || !direccion || !telefono){

alert("Completa todos los datos");

return;

}

//const numeroOrden = "ORD-" + Date.now();

const subtotal = carrito.reduce((a,i)=>a + (i.precio * i.cantidad),0);

const envio = calcularEnvio(subtotal);


try{

const res = await fetch("admin/basedat/guardar_pedido.php",{

method:"POST",

headers:{
"Content-Type":"application/json"
},

body:JSON.stringify({

nombre,
apellido,
direccion,
telefono,
envio,
productos:carrito

})

});

const response = await res.json();

if(response.status !== "ok"){

alert("Error guardando pedido");

return;

}

/* =========================
MENSAJE WHATSAPP
========================= */

let mensaje = `🛒 *Resumen del pedido*%0A%0A`;

carrito.forEach((item,index)=>{

mensaje += `${index+1}. ${item.nombre} x${item.cantidad} - $${(item.precio*item.cantidad).toFixed(2)}%0A`;

});

mensaje += `%0A*Subtotal:* $${subtotal.toFixed(2)}%0A`;
mensaje += `*Envío:* $${envio.toFixed(2)}%0A`;
mensaje += `*Total:* $${(subtotal+envio).toFixed(2)}%0A%0A`;

mensaje += `*Número de orden:* ${response.numero_orden}%0A`;
mensaje += `*Cliente:* ${nombre} ${apellido}%0A`;
mensaje += `*Dirección:* ${direccion}%0A`;
mensaje += `*Teléfono:* ${telefono}%0A`;

const telefonoAsesor = "+573208332827";

window.open(
`https://wa.me/${telefonoAsesor}?text=${mensaje}`,
"_blank"
);

mensaje += `*Número de orden:* ${response.numero_orden}%0A`;
mensajePedidoEl.innerHTML = `
Continua en nuestro canal de whatsapp para solicitar información de pago.
Tu orden es
<strong>${response.numero_orden}</strong>
`;

carrito = [];

localStorage.setItem("carrito", JSON.stringify(carrito));

actualizarContador();

mostrarCarrito();

}
catch(error){

console.error(error);

alert("Error conectando con servidor");

}

});


/* =========================
INICIALIZAR
========================= */

actualizarContador();
mostrarCarrito();

});
